import { useEffect } from "react";
import ChatProvider from "pages/chat/context/chat";
import ChatRoomPage from "pages/chat/chat-room-page";
import LebanonLandingPage from "pages/lebanon-landing";
import useAppLoad from "common/hooks/useAppLoad";
import SplashPage from "pages/splash";

export default function App() {
  const pathname = window.location.pathname;
  const isLebanonLanding = pathname === "/lebanon" || pathname === "/lebanon/";
  const isQatargateWhatsapp =
    pathname === "/qatargate_whatsapp" || pathname === "/qatargate_whatsapp/";
  const { done, isLoaded, isProgressComplete, progress } = useAppLoad({
    incrementProgressValue: 14,
    progressInterval: 260,
    stoppedProgressValue: 84,
    successLoadedTimeout: 900,
  });

  useEffect(() => {
    if (pathname === "/") {
      window.location.replace("/lebanon");
      return;
    }

    if (!isLebanonLanding && !isQatargateWhatsapp) {
      window.location.replace("/lebanon");
    }
  }, [isLebanonLanding, isQatargateWhatsapp, pathname]);

  if (isLebanonLanding) {
    return <LebanonLandingPage />;
  }

  if (!isQatargateWhatsapp) {
    return null;
  }

  if (!isLoaded) {
    return (
      <SplashPage
        isReady={isProgressComplete}
        onContinue={done}
        progress={progress}
      />
    );
  }
  return (
    <ChatProvider>
      <ChatRoomPage />
    </ChatProvider>
  );
}
